import { useEffect, useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import "./game.css";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";

function Casino() {
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const [isLoading, setLoading] = useState(false);
    const [playGame, setPlayGame] = useState(null);
    const [product, setProduct] = useState(null);
    const [profile, setProfile] = useState(null);
    
    const navigate = useNavigate();

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile != res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
    }, []);

    function isMobileDevice() {
        if (window.innerWidth < 800) {
            return true;
        }
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    // Dữ liệu sảnh Casino
    const casinoProviders = [
        { id: "dg99", name: "DG99 CASINO", product_type: "27", game_code: "DG0013", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/lobby/casino/dg99.png" },
        { id: "wm", name: "WM CASINO", product_type: "118", game_code: "WM0001", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/lobby/casino/wm.png" },
        { id: "sexy", name: "SEXY CASINO", product_type: "112", game_code: "SEX001", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/lobby/casino/sexy.png" },
        { id: "ag", name: "AG CASINO", product_type: "4", game_code: "A00070", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/lobby/casino/ag.png" },
        { id: "sa", name: "SA CASINO", product_type: "28", game_code: "SA0001", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/lobby/casino/sa.png" },
        { id: "evo", name: "EVO CASINO", product_type: "86", game_code: "EG0001", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/lobby/casino/evo.png" }
    ];

    // ==========================================
    // LOGIC VÀO GAME & TỰ ĐỘNG CHUYỂN TIỀN VÀO
    // ==========================================
    const launchGame = async (params) => {
        if (localStorage.getItem("profile") == null || localStorage.getItem("profile") == "undefined") {
            navigate("/login");
            return;
        }
        if (isLoading == true) return;
        setLoading(true);

        const form = {
            ...params,
            platform: isMobileDevice() == true ? "html5" : "html5-desktop"
        };

        try {
            // 1. Lấy link game
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/casino/launchgame`, form);
            
            if (res.data.data.status == 0) {
                const gameUrl = res.data.data.game_url;
                setProduct(params.product_type);

                // 2. Tự động nạp toàn bộ số dư vào sảnh (nếu có tiền)
                if (profile && profile.money > 0) {
                    try {
                        await axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                            product_type: params.product_type,
                            type: 1, // 1 là chuyển vào sảnh
                            money: Math.floor(profile.money)
                        });
                    } catch (transferErr) {
                        console.log("Lỗi chuyển tiền vào sảnh:", transferErr);
                    }
                }

                // 3. Hiển thị iframe game
                setPlayGame(gameUrl);
            } else {
                swal("Sảnh đang bảo trì", "Vui lòng chọn sảnh khác", "error");
            }
        } catch (err) {
            if (err.response?.data?.data?.tokenVerificationData?.access == false) {
                swal("Đã xảy ra lỗi", "Vui lòng đăng xuất và đăng nhập lại", "error");
            } else {
                swal("Thất bại", err.response?.data?.message != "internal server error" ? err.response?.data?.message : "Đã có lỗi xảy ra", "error");
            }
        } finally {
            setLoading(false);
        }
    };

    // ==========================================
    // LOGIC THOÁT GAME & TỰ ĐỘNG RÚT TIỀN VỀ
    // ==========================================
    const exitGame = async () => {
        if (isLoading) return;
        
        // Thoát giao diện game về lại sảnh ngay lập tức để người dùng không phải chờ
        setPlayGame(null);
        
        if (!product) return;
        setLoading(true);
        
        try {
            // 1. Kiểm tra số dư đang có trong sảnh
            const resBal = await axios.post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { product_type: product });
            const currentBal = resBal.data.data.balance;

            // 2. Nếu có tiền trong sảnh thì tiến hành rút toàn bộ về ví chính
            if (currentBal > 0) {
                await axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                    product_type: product,
                    type: 2, // 2 là rút từ sảnh ra
                    money: Math.floor(currentBal)
                });
                console.log("Rút tiền sảnh thành công");
            }

            // 3. Cập nhật lại số dư ví hiển thị
            const resProfile = await axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {});
            setProfile(resProfile.data.data);
            localStorage.setItem("profile", JSON.stringify(resProfile.data.data));

        } catch (err) {
            console.log("Rút tiền sảnh thất bại", err);
        } finally {
            setLoading(false);
            setProduct(null);
        }
    };

    return (
        <>
            <style>{`
                .banner img {
                    width: 100%;
                    display: block;
                }
                .content_lobby {
                    background-color: #0b0f17; 
                    min-height: 100vh;
                    padding: 50px 0;
                }
                .casino-cards {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 40px;
                    list-style: none;
                    padding: 0;
                    margin: 0;
                }
                @media (max-width: 900px) {
                    .casino-cards { grid-template-columns: repeat(2, 1fr); }
                }
                @media (max-width: 600px) {
                    .casino-cards { grid-template-columns: 1fr; }
                }
                .animated-flip {
                    position: relative;
                    text-align: center;
                    overflow: hidden;
                    border-radius: 10px;
                    cursor: pointer;
                    padding: 20px 0;
                }
                .cards-content {
                    transition: opacity 0.3s ease;
                }
                .cards-content img {
                    max-width: 100%;
                    height: auto;
                    max-height: 250px;
                    object-fit: contain;
                    display: block;
                    margin: 0 auto;
                }
                .cards-content h3 {
                    color: #ffd700;
                    font-size: 22px;
                    font-weight: bold;
                    margin-top: 15px;
                    text-transform: uppercase;
                }
                
                /* Lớp phủ Hover */
                .cards-btn {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: rgba(0, 0, 0, 0.7);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    opacity: 0;
                    transition: opacity 0.3s ease;
                    border-radius: 10px;
                }
                .animated-flip:hover .cards-btn {
                    opacity: 1;
                }
                .animated-flip:hover .cards-content {
                    opacity: 0.3;
                }
                .cards-btn .p_login {
                    text-decoration: none;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 15px;
                }
                .cards-btn-icon {
                    width: 80px;
                    height: 80px;
                    border: 2px solid #ffd700;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .cards-btn-icon img {
                    width: 45px;
                    height: auto;
                }
                .cards-btn span {
                    color: #ffd700;
                    font-size: 20px;
                    font-weight: bold;
                }

                /* CSS cho khung Iframe Game hiển thị trong trang */
                .embedded-game-container {
                    width: 100%;
                    height: calc(100vh - 60px);
                    display: flex;
                    flex-direction: column;
                    background: #000;
                }
                .embedded-game-header {
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    padding: 8px 15px;
                    background: #111;
                    border-bottom: 2px solid #b71c1c;
                }
                .btn-exit-game {
                    background: #d32f2f;
                    color: #fff;
                    border: none;
                    padding: 8px 20px;
                    border-radius: 5px;
                    cursor: pointer;
                    font-weight: bold;
                    font-size: 14px;
                    text-transform: uppercase;
                    transition: 0.2s;
                }
                .btn-exit-game:active {
                    background: #961616;
                    transform: scale(0.95);
                }
                .embedded-iframe {
                    width: 100%;
                    flex: 1;
                    border: none;
                }
            `}</style>

            <Header profile={profile} />
            
            {isLoading == true ? (
                <div className="loading">
                    <div className="loader"></div>
                </div>
            ) : null}

            {/* ĐIỀU KIỆN HIỂN THỊ: CHƯA VÀO GAME THÌ HIỆN LOBBY, VÀO GAME RỒI THÌ HIỆN IFRAME */}
            {!playGame ? (
                <>
                    <div className="banner">
                        <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/lobby/casino/banner.jpg" alt="Casino Banner" />
                    </div>

                    <main className="content_lobby casino">
                        <div className="container">
                            <ul className="cards-list casino-cards">
                                {casinoProviders.map((provider, index) => (
                                    <li className="animated-flip" key={index}>
                                        <div className="cards-content">
                                            <img src={provider.img} alt={provider.name} />
                                            <h3>{provider.name}</h3>
                                        </div>
                                        <div className="cards-btn">
                                            <a href="#!" onClick={(e) => { e.preventDefault(); launchGame({ product_type: provider.product_type, game_code: provider.game_code }); }} className="p_login">
                                                <div className="cards-btn-icon">
                                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/casino_btn.png" alt="Play" />
                                                </div>
                                                <span>Bắt đầu chơi</span>
                                            </a>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </main>
                </>
            ) : (
                <div className="embedded-game-container">
                    <div className="embedded-game-header">
                        <button className="btn-exit-game" onClick={exitGame}>
                            Thoát Game & Rút Điểm
                        </button>
                    </div>
                    <iframe 
                        src={playGame} 
                        className="embedded-iframe" 
                        title="Casino Game" 
                        allowFullScreen 
                    />
                </div>
            )}
        </>
    );
}

export default Casino;